import React from 'react'
import {RxCross2} from "react-icons/rx"
import logo from "../../asstes/images/mobileLogo.png"
import {AiFillStar} from "react-icons/ai"
import google from "../../asstes/images/googlePlay.png"

const Add = ({setstate}) => {
  return (
    <div className='h-[75px] fixed flex items-center justify-center w-[100%] bg-black text-white'>
        <div className="w-full sm:px-5 px-2">
            <div className='flex items-start justify-between'>
                <div className='flex items-center gap-2'>
                    <div onClick={()=>{setstate(false)}}>
                        <RxCross2 className='text-[20px]'/>
                    </div>
                    <div className=' bg-white w-[50px] h-[50px] rounded-lg flex items-center justify-center'>
                        <img src={logo} alt="" />
                    </div>

                    <div>
                        <h3 className='text-[10px] font-semibold'>Ciberconta</h3>
                        <p className='text-[10px] font-normal'>App para declarar tus impuestos</p>
                        <div className='flex items-center gap-1 text-[#F9A000]'>
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                            <AiFillStar/>
                        </div>
                    </div>
              
                    <div>

                    </div>
                </div>
                <div>
                    <img src={google} alt="" />
                </div>
            </div>
        </div>
    </div>
  )
}

export default Add